export const HOME_LIST_REQUEST = "HOME_LIST_REQUEST";
export const HOME_LIST_SUCCESS = "HOME_LIST_SUCCESS";
export const HOME_LIST_FAIL = "HOME_LIST_FAIL";
